// extracted by css-extract-rspack-plugin
export default {"size276":"276px","wrapper":"unsupported-browser__wrapper___TmPH9"};